<script lang="ts">
	import { createBubbler } from 'svelte/legacy'

	const bubble = createBubbler()
	import Permission from '../Permission.svelte'
	import { t } from '../../../i18n/i18n'

	interface Props {
		title?: string | null
		titleKey?: string | null
		url?: string
		permissions?: string | null
		tag?: import('svelte').Snippet
		isExternal?: boolean
	}

	let {
		title = null,
		titleKey = null,
		url = '#',
		permissions = null,
		tag = undefined,
		isExternal = false
	}: Props = $props()
</script>

<Permission requiredPermissions={permissions}>
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<li role="menuitem" onclick={bubble('click')} style="width: 100%">
		<a class="dropdown__item" href={url} target={isExternal ? '_blank' : undefined}
			>{title ?? $t(titleKey!)}<em>{@render tag?.()}</em></a
		>
	</li>
</Permission>

<style lang="scss">
	@use '$styles/menubar';

	em {
		font-weight: 500;
	}

	.dropdown__item:has(em) {
		gap: 0.25rem;
	}
</style>
